<script setup lang="ts">
import { computed, useSlots } from "vue";

const props = defineProps<{
  label: string;
  /** Optional id linking label to input; auto-generated when absent. */
  id?: string;
  helper?: string;
  error?: string | null;
}>();

let counter = 0;
const generatedId = `field-${++counter}-${Math.random().toString(36).slice(2, 6)}`;
const fieldId = computed(() => props.id ?? generatedId);
const helperId = computed(() => `${fieldId.value}-helper`);
const slots = useSlots();
</script>

<template>
  <div class="flex flex-col gap-1">
    <label :for="fieldId" class="text-2xs font-medium text-fg dark:text-fg-dark">
      {{ label }}
    </label>
    <div>
      <slot :id="fieldId" :describedById="helperId" />
    </div>
    <p
      v-if="error"
      :id="helperId"
      class="text-2xs text-status-failed"
    >{{ error }}</p>
    <p
      v-else-if="helper || slots.helper"
      :id="helperId"
      class="text-2xs text-fg-muted"
    >
      <slot name="helper">{{ helper }}</slot>
    </p>
  </div>
</template>
